import { render, staticRenderFns } from "./PromoRepair.vue?vue&type=template&id=5ef3591e"
import script from "./PromoRepair.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoRepair.vue?vue&type=script&setup=true&lang=js"
import style0 from "@/css/promo-repair/promo-repair.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports